import serviceRegions from "./serviceRegions.json";

export const seoul = ["서울", "서울특별시"];
export const incheon = Object.values(serviceRegions)
  .filter((value) => value.startsWith("인천"))
  .sort();
export const gyeonggi = Object.values(serviceRegions)
  .filter((value) => value.startsWith("경기"))
  .sort();
export const serviceRegionSet = new Set([...incheon, ...gyeonggi]); // except seoul
